import React from 'react';

interface LocalizedUTCDateProps {
  timestampInMilliseconds: number;
}

export function LocalizedUTCDate(props: LocalizedUTCDateProps) {
  return <>{new Date(new Date(props.timestampInMilliseconds).toISOString().split('T').at(0)!).toLocaleDateString()}</>;
}
